@let state = state$ | async;
@if (state) {
    <interacta-dialog
        [isOpen]="state.isOpen"
        [size]="state.content.size"
        [testId]="state.content.testId ?? undefined"
        (closing)="dismiss()"
    >
        <h2 class="typo-t6" title>
            {{ state.content.title | translate: state.content.translationVars }}
        </h2>

        <interacta-dialog-description>
            <span
                [innerHTML]="
                    state.content.description
                        | translate: state.content.translationVars
                "
            ></span>
        </interacta-dialog-description>

        @if (state.content.template) {
            <div content>
                <ng-container *ngTemplateOutlet="state.content.template" />
            </div>
        }

        <interacta-dialog-buttons>
            @if (state.content.cancel) {
                <button
                    data-testid="confirm-dialog-cancel"
                    interacta-dialog-button
                    type="button"
                    [label]="state.content.cancel | translate"
                    [style]="'text'"
                    (click)="close(false)"
                ></button>
            }
            @if (state.content.confirm) {
                <button
                    data-testid="confirm-dialog-confirm"
                    interacta-dialog-button
                    type="button"
                    [label]="state.content.confirm | translate"
                    [style]="'filled'"
                    (click)="close(true)"
                ></button>
            }
        </interacta-dialog-buttons>
    </interacta-dialog>
}
